import { jsx as e } from "react/jsx-runtime";
import * as a from "react";
import { NumericFormat as r } from "../../../node_modules/react-number-format/dist/react-number-format.es.js";
const t = a.forwardRef(function(a2, t2) {
  const { onChange: o, min: n, max: m, name: l, decimalScale: u, ...c } = a2;
  return e(r, { ...c, getInputRef: t2, onValueChange: (e2) => {
    o({ target: { name: l, value: e2.value } });
  }, decimalSeparator: ",", isAllowed: ({ floatValue: e2 }) => !(n && e2 < n) && !(m && e2 > m), decimalScale: u, valueIsNumericString: true, onKeyDown: (e2) => {
    "-" === e2.key && n >= 0 && e2.preventDefault();
  } });
});
export {
  t as NumericFormatCustom
};
//# sourceMappingURL=NumericFormatCustom.js.map
